
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import Header from './components/feature/Header';
import WhatsAppButton from './components/feature/WhatsAppButton';

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <div className="min-h-screen bg-gray-900">
          <Header />
          <main>
            <AppRoutes />
          </main>
          <WhatsAppButton />
        </div>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
